import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Panel, When } from "./Panel";

const GROUPS = [["Matching", /^matched/], ["Missing from TedOps", /^missing/], ["Historical status", /^historical_/], ["Consent evidence", /^evidence_/],
  ["Planned actions", /^plan:/], ["Conflicts & discrepancies", /^(conflict_|CONFLICT|csv_|name_|tedops_)/]];
const KEYS = [["withdrawn", "Unsubscribed"], ["suppressed_subscribers", "Suppressed subscribers"], ["suppression_list", "Suppression list"], ["eligible", "Eligible"], ["with_mailcoach_history", "With Mailcoach history"]];

const Applied = ({ a }) => (
  <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-3 text-xs" data-testid="reconcile-applied">
    <p className="font-semibold text-emerald-900 mb-1">Protections applied {a.finished_at ? new Date(a.finished_at).toLocaleString() : `(${a.status})`} · no consent granted</p>
    <table><tbody>{KEYS.map(([k, l]) => <tr key={k}><td className="pr-4 text-slate-600">{l}</td><td className="pr-4">{(a.before?.[k] ?? 0).toLocaleString()}</td><td>→ <b>{(a.after?.[k] ?? 0).toLocaleString()}</b></td></tr>)}</tbody></table>
    {a.applied && <p className="mt-1 text-slate-600">{Object.entries(a.applied).map(([k, v]) => `${k.replace(/_/g, " ")} ${v.toLocaleString()}`).join(" · ")}</p>}
  </div>
);

export const ReconcilePanel = () => {
  const [d, setD] = useState(null);
  const [a, setA] = useState(null);
  const load = useCallback(() => {
    api.get("/email-marketing/mailcoach-reconcile").then((r) => {
      const dry = r.data.find((x) => x.mode === "dry_run");
      const app = r.data.find((x) => x.mode === "apply_protective");
      if (dry) api.get(`/email-marketing/mailcoach-reconcile/${dry.id}`).then((x) => setD(x.data));
      if (app) setA(app);
    }).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);
  if (!d) return null;
  const c = d.report?.counts || {};
  return (
    <Panel testid="launch-reconcile" title="Mailcoach reconciliation" right={<When at={d.finished_at || d.started_at} />}
      sub={`Dry run of ${d.source} · ${d.status}${d.report ? ` · ${d.report.unique_emails.toLocaleString()} valid unique emails · bulk import days ${d.report.bulk_import_days.join(", ")}` : ""}`}>
      {a && <Applied a={a} />}
      {d.error && <p className="text-xs text-red-600">{d.error}</p>}
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-testid="reconcile-counts">{GROUPS.map(([g, rx]) => (
        <div key={g}><p className="text-xs font-semibold text-slate-700 mb-1">{g}</p>{Object.entries(c).filter(([k]) => rx.test(k)).map(([k, v]) => (
          <div key={k} className="flex justify-between gap-2 text-xs"><span className="text-slate-500">{k.replace(/^(plan:|evidence_|historical_)/, "").replace(/_/g, " ")}</span><b>{Number(v).toLocaleString()}</b></div>))}</div>))}</div>
    </Panel>
  );
};
